import React, { useState } from 'react';
import { Box, TextField, Button, Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { RequestUpdateEmail } from '../services/api';
import { useAuth } from '../contexts/AuthContext';

const EmailUpdateForm: React.FC = () => {
    const [currentEmail, setCurrentEmail] = useState<string>('');
    const [message, setMessage] = useState<string>('');
    const navigate = useNavigate();
    const { token, refreshTokenFunction, logout } = useAuth();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            if (token !== null) {
                await RequestUpdateEmail(currentEmail, token);
                setMessage('メールアドレス変更リクエストが送信されました。');
            }
        } catch (error: any) {
            // 401の場合はリフレッシュトークンで再取得を試みる
            if (error.response && error.response.status === 401) {
                try {
                    const newToken = await refreshTokenFunction();
                    if (newToken) {
                        await RequestUpdateEmail(currentEmail, newToken);
                        setMessage('メールアドレス変更リクエストが送信されました。');
                        return;
                    }
                } catch (refreshError) {}
            }
            setMessage('エラーが発生しました。もう一度お試しください。');
        }
    };

    return (
        <Container maxWidth="sm">
            <Box
                component="form"
                onSubmit={handleSubmit}
                sx={{
                    mt: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                }}
            >
                <Typography variant="h6" component="div">
                    メールアドレス変更リクエスト
                </Typography>
                <TextField
                    label="現在のメールアドレス"
                    type="email"
                    variant="outlined"
                    fullWidth
                    value={currentEmail}
                    onChange={(e) => setCurrentEmail(e.target.value)}
                    required
                />
                {message && (
                    <Typography variant="body2" color="textSecondary">
                        {message}
                    </Typography>
                )}
                <Button type="submit" variant="contained" color="primary">
                    送信
                </Button>
                <Button variant="outlined" color="secondary" onClick={() => navigate('/')}>
                    戻る
                </Button>
            </Box>
        </Container>
    );
};

export default EmailUpdateForm;
